<template>
    <div class="card-body">

        <title-header title="Carta de Tupã"></title-header>

        <p class="card-text">
            A União Geral dos Trabalhadores do Estado de São Paulo (UGT/SP),
            reunida em Tupã, dia 22 de junho de 2017, a fim de consolidar suas
            estratégias de ação combativas às reformas trabalhista e
            previdenciária, entende que sua atuação junto às entidades filiadas
            e aos trabalhadores por ela representados deve estar cada vez mais
            engajada e comprometida, entre si, e com a UGT Nacional, no
            enfrentamento destas propostas do governo federal, lesivas aos
            trabalhadores, aposentados e pensionistas.
        </p>
        <p class="card-text">
            Estas reformas podem até ser necessárias, mas no formato proposto
            revelam ser uma ameaça à proteção social e significarão enorme
            retrocesso cidadão. Daí, nosso compromisso em combater e denunciar o
            caráter perverso das reformas que prejudicam, principalmente, os
            mais pobres, ou os que dependem de salário ou de benefícios
            previdenciários ou assistenciais.
        </p>
        <p class="card-text">
            Unida, participativa e mobilizada no Congresso Nacional, na mídia e
            na sociedade em geral, a UGT/SP reitera a sua posição de exercer um
            sindicalismo de resistência. Esta resistência conjunta com as suas
            entidades filiadas não se opõe à atualização das relações de
            trabalho. Repudia, entretanto, as práticas antissindicais e toda e
            qualquer forma de precarização e retirada de direitos trabalhistas e
            previdenciários.
        </p>
        <p class="card-text">
            A UGT/SP não aceita, passivamente, o desmonte do Estado em favor do
            capital e da precarização do trabalho. Conclama a todos que têm
            compromisso com o País e com a paz social para lutar e impedir a
            demolição das relações capital e trabalho. Nossa Central não está
            alheia a esta investida neoliberal e cumprirá sua missão de defender
            os trabalhadores e as trabalhadoras do Estado de São Paulo com a
            preservação do bem-estar social e das conquistas do movimento
            sindical brasileiro.
        </p>
        <p class="card-text">
            As 15 propostas a seguir têm como objetivo reforçar a presença da
            UGT/SP em toda a sua base com a reafirmação das suas bandeiras de
            luta, bem como das suas contribuições para a superação das crises
            nacionais. Neste quesito deve prevalecer a manutenção e a geração de
            emprego, renda e preservação dos direitos.
        </p>
        <p class="card-text">
            Propomos:
        </p>
        <ol>
            <li>
                1 - Pressionar para que as reformas trabalhista e previdenciária
                sejam rejeitadas no Congresso Nacional.
            </li>
            <li>
                2 - Fortalecer a luta contra intervenções na estrutura e na
                organização sindical.
            </li>
            <li>
                3 - Ampliar a defesa e a viabilidade da pauta unitária da classe
                trabalhadora, aprovada na Conclat de 2010.
            </li>
            <li>
                4 - Fazer valer as reivindicações do documento unitário
                “Compromisso pelo Desenvolvimento”, assinado pelas Centrais.
            </li>
            <li>
                5 - Numa conjuntura de recessão, inflação, desemprego, juros
                altos e consumo retraído, potencializar a apresentação de
                propostas para incentivar a retomada da indústria, do comércio e
                serviços.
            </li>
            <li>
                6 - Utilizar os meios de comunicação, ainda mais as redes
                sociais das entidades, para desmascarar a alegação do governo de
                que a retomada do crescimento econômico será alcançada
                decretando o fim dos direitos trabalhistas, sociais e
                previdenciários.
            </li>
            <li>
                7 - Manter cuidado redobrado sobre o interesse de o governo
                favorecer a visão rentista contra os trabalhadores, que inibe a
                produção interna.
            </li>
            <li>
                8 - Incentivar o diálogo da UGT/SP com os poderes Executivo e
                Legislativo federais para ampliar nosso repúdio contra as
                reformas, com firme participação da Central nos atos que visem
                este fim.
            </li>
            <li>
                9 - Fortalecer a representatividade sindical desde o local de
                trabalho.
            </li>
            <li>
                10 - Intensificar o trabalho de base, inclusive com campanha de
                filiação, e organização de seminários e debates sobre a
                conjuntura.
            </li>
            <li>
                11 - Promover cursos de formação político e sindical, bem como
                fornecer, gratuitamente, aulas de oratória e comunicação, a fim
                de formar novos quadros.
            </li>
            <li>
                12 - Produzir material de referência sobre os temas de interesse
                do movimento sindical.
            </li>
            <li>
                13 - Atrair jovens e mulheres para o movimento sindical.
            </li>
            <li>
                14 - Fomentar articulações com os demais movimentos sociais.
            </li>
            <li>
                15 - Definir um calendário de eventos previamente agendados
                aberto aos trabalhadores.
            </li>
        </ol>
        <p class="card-text">
            Saudações Sindicais
        </p>
        <p class="card-text">
            Tupã, 22 de junho de 2017
        </p>
    </div>
</template>

<script>
export default {
    name: "carta-de-tupa"
};
</script>

<style lang="scss" scoped>
.card-body {
    @apply p-20 pt-0;
    @media (max-width: 1024px) {
        @apply p-4;
    }

    .card-text {
        @apply my-4 text-base;
    }

    ol {
        li {
            @apply text-base;
        }
    }
}
</style>
